// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"246":"8f6959b9","594":"878f2291","671":"05beea8b"}[chunkId] + ".js";
};